// UI visibility only. The API remains the authority for every operation.
export const hasAction = (types = [], action) => types.includes(action) || types.includes('ADMIN')

export const piiActions = (page, ordinaryActions) => {
  if (page === 'PARTICIPANT_PII' || page === 'REPORT_PII') return ['VIEW', 'EXPORT']
  if (page === 'MASTER_PARTICIPANT_PII' || page === 'USER_PII') return ['VIEW']
  return ordinaryActions
}

export const isMasked = (value) => value === '***'

export const displayMobile = (value) => {
  if (value === null || value === undefined) return ''
  const text = String(value)
  // Format legacy nine-digit numbers only; never modify a server mask.
  return /^[1-9]\d{8}$/.test(text) ? `0${text}` : text
}

export const userPatch = (original, values, roleId, canViewPii) => {
  const patch = {}
  if (canViewPii) {
    for (const field of ['firstname', 'lastname', 'email']) {
      if (values[field] !== original[field] && !isMasked(values[field])) patch[field] = values[field]
    }
  }
  if (roleId !== null && roleId !== undefined && String(roleId) !== String(original.role_id)) {
    patch.role_id = roleId
  }
  return patch
}

export const canAssignUserRole = (userTypes = [], roleTypes = []) =>
  userTypes.includes('ADMIN') || hasAction(roleTypes, 'EDIT')
